module.exports = __webpack_public_path__ + "img/new-people-courier-walk.d6c44edf.png";